// Тот же навy+золото, что и в мобильном приложении и в мастер-плане проекта.
export const colors = {
  bg: '#0e1730',
  surface: '#16213f',
  surface2: '#1c294a',
  text: '#ece7da',
  textMuted: '#9aa3bd',
  accent: '#d4b06a',
  accentStrong: '#e6c583',
  border: '#283355',
  good: '#6fbf8b',
  warn: '#e0ab55',
  danger: '#d98080',
};
